import { get, putJson } from '../httpClient';

/**
 * Client for /api/org/:orgId/calendar-events.
 *
 * Org calendar events live on the OWNER's privateData (moved out of the
 * public org profile on 1 Sep 2026 — participant names and meeting links were
 * world-readable there). Team members can't see the owner's private data, so
 * this wrapper proxies through the server's Integration SDK for both reads
 * (any member) and writes (EDIT_ANY_SHOW).
 *
 * Writes are full-array replacements — the duck builds the new full list
 * and the server overwrites the calendarEvents field on just the matching
 * org profile entry.
 */
export const orgCalendarAPI = {
  /** GET /api/org/:orgId/calendar-events */
  listEvents: orgId => get(`/api/org/${orgId}/calendar-events`),

  /** PUT /api/org/:orgId/calendar-events */
  updateEvents: (orgId, events) =>
    putJson(`/api/org/${orgId}/calendar-events`, { events }),
};
